import LibUtils from "lib/LibUtils";

interface IDeepMergeOptions {
    arrayMerge?: Function;
    isMergeableObject?: (value: any) => boolean;
}

function isMergeableObject(value: any): boolean {
    return LibUtils.isNonNullObject(value) && !LibUtils.isSpecial(value);
}


/**
 * Retorna um novo Array resultante da mixagem (em pronfundidade) de dois objetos.
 * @param target
 * @param source
 * @param options
 */
export function deepMerge<T>(target: T, source: DeepPartial<T>, options?: IDeepMergeOptions): T {
    options = options || {};
    options.arrayMerge = options.arrayMerge || defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || isMergeableObject;

    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

    if (!sourceAndTargetTypesMatch) {
        return cloneUnlessOtherwiseSpecified(source, options);
    } else if (sourceIsArray) {
        return options.arrayMerge(target, source, options);
    } else {
        return mergeObject(target, source, options);
    }
}

export function deepmergeAll<T>(array: Array<DeepPartial<T>>, options: IDeepMergeOptions): T {
    if (!Array.isArray(array)) {
        throw new Error('first argument should be an array');
    }

    var result = {} as T;

    array.forEach((v) => {
        result = deepMerge(result, v, options);
    });

    return result;
}


function emptyTarget(val: any) {
    return Array.isArray(val) ? [] : {};
}

function cloneUnlessOtherwiseSpecified(value: any, options: any): any {
    return (options.clone !== false && options.isMergeableObject(value))
        ? deepMerge(emptyTarget(value), value, options)
        : value;
}

function defaultArrayMerge(target: any, source: any, options: any) {
    return target.concat(source).map(function (element: any) {
        return cloneUnlessOtherwiseSpecified(element, options);
    });
}

function mergeObject<T>(target: T, source: DeepPartial<T>, options: any): T {
    var destination = {} as T;
    if (options.isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
            destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
        });
    }
    Object.keys(source).forEach(function (key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
        } else {
            destination[key] = deepMerge(target[key], source[key], options);
        }
    });
    return destination;
}
